/* Dreya: Garment measurements button + bottom sheet (Option B2)
   Vanilla JS, no dependencies. One instance per [data-dgm] root.

   The sheet is opened by any element with [data-dgm-open] (the small
   "Garment measurements" button next to "Size guide").
   Inside the sheet the customer can pick a size, read the real garment
   measurements and add that size to the bag directly.

   Events fired on document:
     dreya:gm:open                 detail: { size }
     dreya:gm:size                 detail: { size }
     dreya:cart:added              detail: { variantId, size, item }
   Hook for the theme (optional):
     window.DreyaGM.onAdded = function (detail) { ...refresh cart drawer / count... }
*/
(function () {
  'use strict';

  /* ---- Garment sketches. Coordinates match the approved design. ----
     Each sketch lists the measurement keys it can draw. Rows in the
     metafield whose key is not listed here still show in the list,
     they just have no line on the drawing. */
  var SKETCHES = {
    'kurta-top': {
      viewBox: '0 0 290 318',
      label: 'Line sketch of the top with measurement lines',
      outline: '<path class="dgm__outline" d="M105 40 L70 52 L30 160 L52 167 L78 102 L76 150 L60 292 L200 292 L184 150 L182 102 L208 167 L230 160 L190 52 L155 40 Q130 80 105 40 Z"/>' +
               '<path class="dgm__detail" d="M130 70 L130 108"/>',
      lines: {
        shoulder: 'M70 26 L190 26 M70 20 L70 32 M190 20 L190 32',
        bust:     'M79 110 L181 110 M79 104 L79 116 M181 104 L181 116',
        waist:    'M77 150 L183 150 M77 144 L77 156 M183 144 L183 156',
        length:   'M258 40 L258 292 M252 40 L264 40 M252 292 L264 292',
        sleeve:   'M58 48 L20 156 M53.3 46.3 L62.7 49.7 M15.3 154.3 L24.7 157.7',
        hem:      'M60 302 L200 302 M60 296 L60 308 M200 296 L200 308'
      }
    },
    'pant': {
      viewBox: '0 0 220 320',
      label: 'Line sketch of the pant with measurement lines',
      outline: '<rect class="dgm__outline" x="50" y="28" width="100" height="14"/>' +
               '<path class="dgm__outline" d="M50 42 L40 296 L96 296 L100 120 L104 296 L160 296 L150 42 Z"/>' +
               '<path class="dgm__detail" style="stroke-dasharray:none;stroke-width:.6" d="M60 30 L60 40 M70 30 L70 40 M80 30 L80 40 M90 30 L90 40 M100 30 L100 40 M110 30 L110 40 M120 30 L120 40 M130 30 L130 40 M140 30 L140 40"/>',
      lines: {
        waist:  'M50 16 L150 16 M50 10 L50 22 M150 10 L150 22',
        hip:    'M48.5 80 L151.5 80 M48.5 74 L48.5 86 M151.5 74 L151.5 86',
        length: 'M188 28 L188 296 M182 28 L194 28 M182 296 L194 296',
        hem:    'M40 306 L96 306 M40 300 L40 312 M96 300 L96 312'
      }
    }
  };

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function readJSON(root, sel) {
    var el = root.querySelector(sel);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function GM(root) {
    this.root = root;
    this.data = readJSON(root, '[data-dgm-data]');
    this.product = readJSON(root, '[data-dgm-product]');
    if (!this.data || !this.data.parts || !this.data.parts.length) return;
    this.demo = root.hasAttribute('data-dgm-demo');
    this.baseUnit = this.data.unit === 'cm' ? 'cm' : 'in';
    this.state = { size: null, unit: this.baseUnit, part: 0, hl: null };
    this.sheet = root.querySelector('.dgm__sheet');
    this.el = {
      sizes: root.querySelector('[data-dgm-sizes]'),
      tabs: root.querySelector('[data-dgm-tabs]'),
      sketch: root.querySelector('[data-dgm-sketch]'),
      rows: root.querySelector('[data-dgm-rows]'),
      add: root.querySelector('[data-dgm-add]'),
      error: root.querySelector('[data-dgm-error]')
    };
    this.sizeOptionIndex = this.findSizeOptionIndex();
    this.bind();
  }

  GM.prototype.findSizeOptionIndex = function () {
    if (!this.product || !this.product.options) return -1;
    for (var i = 0; i < this.product.options.length; i++) {
      var o = this.product.options[i];
      var name = typeof o === 'string' ? o : (o && o.name) || '';
      if (/size/i.test(name)) return i;
    }
    return -1;
  };

  /* Current variant chosen in the theme's product form (keeps colour etc.) */
  GM.prototype.themeForm = function () {
    var scope = this.root.closest('section, [id^="MainProduct"], main') || document;
    return scope.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
  };
  GM.prototype.currentVariant = function () {
    if (!this.product) return null;
    var form = this.themeForm();
    var idInput = form && form.querySelector('[name="id"]');
    var id = idInput && Number(idInput.value);
    var vs = this.product.variants || [];
    for (var i = 0; i < vs.length; i++) if (vs[i].id === id) return vs[i];
    return vs[0] || null;
  };
  GM.prototype.variantFor = function (size) {
    if (!this.product) return null;
    var vs = this.product.variants || [];
    var idx = this.sizeOptionIndex;
    if (idx < 0) return vs.length === 1 ? vs[0] : null;
    var cur = this.currentVariant();
    var best = null;
    for (var i = 0; i < vs.length; i++) {
      var v = vs[i];
      if (v.options[idx] !== size) continue;
      var same = true;
      if (cur) for (var j = 0; j < v.options.length; j++) if (j !== idx && v.options[j] !== cur.options[j]) same = false;
      if (same) return v;
      if (!best) best = v;
    }
    return best;
  };

  /* Read / write the theme's own size picker so both stay in sync.
     Dreya (21 Oct 2026): sizes are buttons .size-grid .size-btn[data-value], the chosen one has .selected.
     Clicking one runs the theme's own handler, which sets #variant-id and the stock line. */
  GM.prototype.themeSizeButtons = function () {
    return Array.prototype.slice.call(document.querySelectorAll('.size-grid .size-btn[data-value]'));
  };
  GM.prototype.readThemeSize = function () {
    var sel = document.querySelector('.size-grid .size-btn.selected[data-value]');
    return sel ? sel.getAttribute('data-value') : null;
  };
  GM.prototype.writeThemeSize = function (size) {
    var btns = this.themeSizeButtons();
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].getAttribute('data-value') === size) {
        if (!btns[i].classList.contains('selected') && !btns[i].classList.contains('sold-out')) btns[i].click();
        return;
      }
    }
  };

  GM.prototype.fmt = function (v) {
    if (v === null || v === undefined || v === '') return '–';
    var n = Number(v);
    if (this.state.unit === this.baseUnit) return this.baseUnit === 'in' ? n + '"' : n + ' cm';
    if (this.state.unit === 'cm') return Math.round(n * 2.54) + ' cm';
    return (Math.round((n / 2.54) * 2) / 2) + '"';
  };

  /* 21 Oct 2026: "Ask us on WhatsApp" goes straight to WhatsApp, nothing in between.
     The message names the product and the size she is looking at, so the reply can start with an answer. */
  GM.prototype.bindAsk = function () {
    var self = this, wa = this.root.querySelector('.dgm__wa');
    if (!wa) return;
    var base = (wa.getAttribute('href') || '').split('?')[0] || 'https://wa.me/919632729623';
    wa.addEventListener('click', function (e) {
      e.stopPropagation();
      var title = (self.product && self.product.title) || '';
      var msg = 'Hi Dreya, I have a question about the size for ' + title + (self.state.size ? ' (size ' + self.state.size + ')' : '') + '.';
      var url = base + '?text=' + encodeURIComponent(msg);
      wa.setAttribute('href', url);
      /* open from script, not by following the link, so Shopify's "leave the store?" screen never shows */
      e.preventDefault();
      var w = window.open(url, '_blank');
      if (w) { try { w.opener = null; } catch (err) {} } else { window.location.href = url; }
    }, true);
  };
  GM.prototype.bind = function () {
    var self = this;
    document.querySelectorAll('[data-dgm-open]').forEach(function (b) {
      b.addEventListener('click', function () { self.lastTrigger = b; self.open(); });
    });
    this.root.querySelectorAll('[data-dgm-close]').forEach(function (b) {
      b.addEventListener('click', function () { self.close(); });
    });
    this.root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') self.close();
      if (e.key === 'Tab') self.trapFocus(e);
    });
    this.root.querySelectorAll('[data-unit]').forEach(function (b) {
      b.addEventListener('click', function () { self.state.unit = b.getAttribute('data-unit'); self.render(); });
    });
    this.el.add.addEventListener('click', function () { self.addToBag(); });
    this.bindAsk();
  };

  GM.prototype.open = function () {
    var themeSize = this.readThemeSize();
    if (themeSize && this.data.sizes.indexOf(themeSize) > -1) this.state.size = themeSize;
    var part = this.data.parts[this.state.part];
    this.state.hl = part.rows[0] && part.rows[0].key;
    this.el.error.textContent = '';
    this.root.hidden = false;
    document.body.classList.add('dgm-lock');
    this.render();
    var close = this.root.querySelector('.dgm__close');
    if (close) close.focus();
    document.dispatchEvent(new CustomEvent('dreya:gm:open', { detail: { size: this.state.size } }));
  };
  GM.prototype.close = function () {
    this.root.hidden = true;
    document.body.classList.remove('dgm-lock');
    if (this.lastTrigger) this.lastTrigger.focus();
  };
  GM.prototype.trapFocus = function (e) {
    var f = this.sheet.querySelectorAll('button:not([disabled]), a[href]');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
    else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
  };

  GM.prototype.render = function () {
    var self = this, st = this.state, d = this.data;
    var si = st.size ? d.sizes.indexOf(st.size) : -1;
    var part = d.parts[st.part];

    // Sizes
    this.el.sizes.innerHTML = d.sizes.map(function (s) {
      var v = self.variantFor(s);
      var soldOut = self.product && v && v.available === false;
      return '<button type="button" class="dgm__size" data-size="' + esc(s) + '" aria-pressed="' + (st.size === s) + '"' +
        (soldOut ? ' disabled aria-label="' + esc(s) + ', sold out"' : '') + '>' + esc(s) + '</button>';
    }).join('');
    this.el.sizes.querySelectorAll('[data-size]').forEach(function (b) {
      b.addEventListener('click', function () {
        st.size = b.getAttribute('data-size');
        self.el.error.textContent = '';
        self.writeThemeSize(st.size);
        document.dispatchEvent(new CustomEvent('dreya:gm:size', { detail: { size: st.size } }));
        self.render();
        var again = self.el.sizes.querySelector('[data-size="' + st.size + '"]');
        if (again) again.focus();
      });
    });

    // Units
    this.root.querySelectorAll('[data-unit]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-unit') === st.unit));
    });

    // Tabs (hidden when the garment has one part, e.g. a dress)
    this.el.tabs.hidden = d.parts.length < 2;
    this.el.tabs.innerHTML = d.parts.map(function (p, i) {
      return '<button type="button" role="tab" class="dgm__tab" data-part="' + i + '" aria-selected="' + (i === st.part) + '">' + esc(p.label) + '</button>';
    }).join('');
    this.el.tabs.querySelectorAll('[data-part]').forEach(function (b) {
      b.addEventListener('click', function () {
        st.part = Number(b.getAttribute('data-part'));
        var p = d.parts[st.part];
        st.hl = p.rows[0] && p.rows[0].key;
        self.render();
      });
    });

    // Sketch
    var sk = SKETCHES[part.sketch];
    if (sk) {
      var lines = part.rows.filter(function (r) { return sk.lines[r.key]; }).map(function (r) {
        return '<path class="dgm__m' + (st.hl === r.key ? ' is-on' : '') + '" d="' + sk.lines[r.key] + '"/>';
      }).join('');
      this.el.sketch.innerHTML = '<svg viewBox="' + sk.viewBox + '" role="img" aria-label="' + esc(sk.label) + '">' + sk.outline + lines + '</svg>';
      this.el.sketch.classList.toggle('has-on', !!st.hl);
      this.el.sketch.hidden = false;
    } else {
      this.el.sketch.innerHTML = '';
      this.el.sketch.hidden = true;
    }

    // Rows
    this.el.rows.innerHTML = part.rows.map(function (r) {
      var val = si > -1 ? self.fmt(r.values[si]) : '–';
      return '<li><button type="button" class="dgm__row" data-key="' + esc(r.key) + '" aria-pressed="' + (st.hl === r.key) + '">' +
        '<span class="dgm__row-label"><span class="dgm__dot" aria-hidden="true"></span>' + esc(r.label) + '</span>' +
        '<span class="dgm__row-val">' + esc(val) + '</span></button></li>';
    }).join('');
    this.el.rows.querySelectorAll('[data-key]').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-key');
        st.hl = st.hl === k ? null : k;
        self.render();
        var again = self.el.rows.querySelector('[data-key="' + k + '"]');
        if (again) again.focus();
      });
    });

    // Add to bag
    var v = st.size ? this.variantFor(st.size) : null;
    var soldOut = this.product && v && v.available === false;
    this.el.add.disabled = !st.size || soldOut;
    this.el.add.textContent = !st.size ? 'Select a size above' : soldOut ? 'Size ' + st.size + ' sold out' : 'Add size ' + st.size + ' to bag';
  };

  GM.prototype.addToBag = function () {
    var self = this, size = this.state.size;
    if (!size) return;
    var btn = this.el.add;
    if (this.demo) { this.close(); this.toast(size); return; }
    var v = this.variantFor(size);
    if (!v) { this.el.error.textContent = 'This size is not available right now.'; return; }
    btn.setAttribute('aria-busy', 'true'); btn.disabled = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    }).then(function (j) {
      var detail = { variantId: v.id, size: size, item: j.items ? j.items[0] : j };
      self.close();
      if (typeof window.dreyaCartAdded === 'function') window.dreyaCartAdded(); else self.toast(size);
      document.dispatchEvent(new CustomEvent('dreya:cart:added', { detail: detail }));
      if (window.DreyaGM && typeof window.DreyaGM.onAdded === 'function') window.DreyaGM.onAdded(detail);
    }).catch(function (err) {
      self.el.error.textContent = (err && (err.description || err.message)) || 'Could not add to bag. Please try again.';
    }).then(function () {
      btn.removeAttribute('aria-busy'); self.render();
    });
  };

  GM.prototype.toast = function (size) {
    var old = document.querySelector('.dgm-toast');
    if (old) old.remove();
    var t = document.createElement('div');
    t.className = 'dgm-toast';
    t.setAttribute('role', 'status');
    var cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart';
    t.innerHTML = '<span>Added to bag · Size ' + esc(size) + '</span><a href="' + cartUrl + '">View bag</a>';
    document.body.appendChild(t);
    setTimeout(function () { if (t.parentNode) t.remove(); }, 4000);
  };

  function init() {
    document.querySelectorAll('[data-dgm]').forEach(function (root) {
      if (!root.__dgm) root.__dgm = new GM(root);
    });
  }
  window.DreyaGM = window.DreyaGM || {};
  window.DreyaGM.init = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
